module.exports = __webpack_public_path__ + "img/notice.962b346a.png";